import { createFileRoute, redirect } from "@tanstack/react-router";

/** Die Seite heißt seit dem Rundgang vom 12.09.2026 „Zustellungen" — alte Links laufen weiter. */
export const Route = createFileRoute("/_angemeldet/_mitarbeiter/erinnerungen")({
	beforeLoad: () => {
		throw redirect({ to: "/zustellungen", replace: true });
	},
});
